export default {
    messageBrokerUrl: 'wss://broker.mqtt.guandb.cn/mqtt',
    openObserveOption: {
        clientToken: 'rumKDcqkNzF7pEzjo3w',
        applicationId: 'activity',
        site: 'analyze.guandb.cn',
        service: 'activity',
        organizationIdentifier: 'guandb',
        insecureHTTP: false,
        apiVersion: 'v1',
    },
    qqMapKey: 'WJPBZ-NLVY3-WJ337-O4BZU-55RD5-CIBWD'
}
